export default class PrintList {

    static initializeEvents() {
        const printListButton = document.querySelectorAll('[title="Imprimer cette liste"]');
        const listPrintElements = Array.from(document.querySelectorAll('[data-printlist-hidden], [data-printlist-nomargin]'));

        this.listButtonListener(printListButton, listPrintElements);
    }

    static listButtonListener(printListButton, listPrintElements) {
        printListButton.forEach(button => {
            button.addEventListener('click', function () {
                listPrintElements.forEach(element => {
                    if (element.hasAttribute('data-printlist-hidden')) {
                        element.classList.add('hidden-print');
                    }

                    if (element.hasAttribute('data-printlist-nomargin')) {
                        element.classList.remove('mt-12w');
                    }
                });

                window.print();

                listPrintElements.forEach(element => {
                    if (element.hasAttribute('data-printlist-hidden')) {
                        element.classList.remove('hidden-print');
                    }

                    if (element.hasAttribute('data-printlist-nomargin')) {
                        element.classList.add('mt-12w');
                    }
                });
            });
        })
    }

}